import {createSelector} from 'reselect';

export const getModalState = (state) => state.modalState;
export const getModalStore = (state) => state.modalStore;

export const getModalShow = createSelector([getModalState], (modalState) => modalState.show);
const getModalType = createSelector([getModalState], (modalState) => modalState.type);
const getModalMode = createSelector([getModalState], (modalState) => modalState.mode);
const getModalSize = createSelector([getModalState], (modalState) => modalState.size);
const getModalInlineMessage = createSelector([getModalState], (modalState) => modalState.inlineMessage);
const getHideCloseButton = createSelector([getModalState], (modalState) => modalState.hideCloseButton);
const getDisableBlur = createSelector([getModalState], (modalState) => modalState.disableBlur);
export const getHeader = createSelector([getModalState], (modalState) => modalState.header);
export const getContent = createSelector([getModalState], (modalState) => modalState.content);
export const getActions = createSelector([getModalState], (modalState) => modalState.actions);

export const getModalCommon = createSelector(
  [getModalShow, getModalSize, getModalInlineMessage, getHeader, getContent, getActions],
  (show, size, inlineMessage, header, content, actions) => ({
    show,
    size,
    inlineMessage,
    header,
    content,
    actions,
  }),
);

export const getModal = createSelector(
  [getModalShow, getModalType, getModalSize, getModalInlineMessage, getHideCloseButton, getDisableBlur],
  (show, type, size, inlineMessage, hideCloseButton, disableBlur) => ({
    show,
    type,
    size,
    inlineMessage,
    hideCloseButton,
    disableBlur,
  }),
);

export const getMainRootModal = createSelector([getModalMode], (mode) => ({mode}));

export const getMainPopUp = createSelector([getModalStore], (modalStore) => ({
  popUpVisible: modalStore.popUpVisible,
  popUpTitle: modalStore.popUpTitle,
  popUpText: modalStore.popUpText,
  popUpButton: modalStore.popUpButton,
  popUpQuestion: modalStore.popUpQuestion,
  popUpClose: modalStore.popUpClose,
  popUpHideCloseButton: modalStore.popUpHideCloseButton,
}));

export const getMainNumpadModal = createSelector([getModalStore], (modalStore) => ({
  modalVisible: modalStore.modalVisible,
  modalHeader: modalStore.modalHeader,
  modalTitle: modalStore.modalTitle,
  value: modalStore.value,
  callback: modalStore.callback,
  incrementValue: modalStore.incrementValue,
  minValue: modalStore.minValue,
  maxValue: modalStore.maxValue,
  maxDigitAfterDecimal: modalStore.maxDigitAfterDecimal,
  validatorInput: modalStore.validatorInput,
  numpadMode: modalStore.numpadMode,
  unit: modalStore.unit,
  info: modalStore.info,
}));

export const getMainVirtualKeyboard = createSelector([getModalStore], (modalStore) => ({
  keyboardVisible: modalStore.keyboardVisible,
  keyboardValue: modalStore.keyboardValue,
  keyboardTitle: modalStore.keyboardTitle,
  keyboardCallBack: modalStore.keyboardCallBack,
  overwriteFirstInput: modalStore.overwriteFirstInput,
  keyboardPlaceholder: modalStore.keyboardPlaceholder,
  max: modalStore.max,
  keyboardCancel: modalStore.keyboardCancel,
  disableSymbols: modalStore.disableSymbols,
}));
